import { createContext, useContext } from 'react'
import { defaultTranslations, type WebchatTranslations } from '../translations'

const TranslationContext = createContext<WebchatTranslations>(defaultTranslations)

export const TranslationProvider = TranslationContext.Provider

export function useTranslations(): WebchatTranslations {
  return useContext(TranslationContext)
}
